import { forwardRef } from 'react';
import './styles.scss';

const SeoTextFranchise = forwardRef<HTMLElement>((_, ref) => (
  <section ref={ref} id='seo' className='seo-text-section'>
    <div className='seo-text-section__container'>
      <h2 className='seo-text-section__title'>
        Франшиза устричных баров «Деликатеска»
      </h2>

      <div className='seo-text-section__content'>
        <h3 className='seo-text-section__subtitle'>
          Наши главные преимущества
        </h3>
        <p className='seo-text-section__text'>
          Франшиза устричных баров «Деликатеска» создана на основе действующей
          концепции, которая уже доказала свою эффективность на рынке. Мы
          работаем со свежими морепродуктами, контролируем качество на всех
          этапах и выстраиваем прямые поставки от проверенных партнеров. В меню
          входят устрицы, морские ежи, гребешки и другие живые морепродукты, а
          также авторские блюда и напитки. Концепция подходит для крупных
          городов, включая Москву, где сохраняется высокий спрос на качественную
          морскую кухню.
        </p>

        <h3 className='seo-text-section__subtitle'>
          Как вы будете зарабатывать
        </h3>
        <p className='seo-text-section__text'>
          Основной доход формируется за счет продаж в заведении, заказов навынос
          и сервиса доставки. Дополнительную выручку обеспечивают дегустации,
          специальные мероприятия и сезонные предложения. Формат позволяет
          работать как с постоянными гостями, так и с новой аудиторией, которая
          хочет купить свежие морепродукты по доступной цене.
        </p>

        <h3 className='seo-text-section__subtitle'>
          Инвестиции для открытия бизнеса
        </h3>
        <p className='seo-text-section__text'>
          Размер вложений зависит от выбранного формата и площади помещения. Мы
          помогаем подобрать локацию, проверить показатели трафика и подготовить
          проект к запуску. Продажа франшизы устричных баров включает готовые
          бизнес-процессы, стандарты обслуживания и рекомендации по закупкам.
        </p>

        <h3 className='seo-text-section__subtitle'>Пакет франшизы</h3>
        <p className='seo-text-section__text'>
          В пакет входит брендбук, операционные регламенты, инструкции для
          персонала, маркетинговые материалы и помощь в запуске. Франчайзинг
          предполагает передачу накопленного опыта и готовых решений, которые
          помогают быстрее выйти на рынок и начать продавать востребованный
          продукт.
        </p>

        <h3 className='seo-text-section__subtitle'>Обучение и поддержка</h3>
        <p className='seo-text-section__text'>
          Команда сопровождает партнеров на всех этапах развития проекта. Мы
          обучаем персонал, помогаем организовать поставки, проверять качество
          продукции и выстраивать работу предприятия. Поддержка продолжается и
          после открытия.
        </p>

        <h3 className='seo-text-section__subtitle'>Требования</h3>
        <p className='seo-text-section__text'>
          Для сотрудничества важны заинтересованность в развитии проекта,
          готовность соблюдать стандарты сети и обеспечивать хороший сервис.
          Франшиза подойдет предпринимателям, которые хотят открыть современный
          устричный бар и развивать прибыльный бизнес. Продажа осуществляется
          после согласования локации и оценки перспектив проекта. Мы готовы
          рассматривать партнеров как в Москве, так и в других регионах.
        </p>
      </div>
    </div>
  </section>
));

export default SeoTextFranchise;
